module.exports = __webpack_public_path__ + "header-logo.webp?95446dbf07d3c23542da9ff4a1790766";